import { MotivoEsitoSpedizione } from './tipologiche/motivo-esito-spedizione';
import { TipoEsitoSpedizione } from './tipologiche/tipo-esito-spedizione';

export class EsitoSpedizioneDiffida {
    id: string;
    dataSpedizione: number;
    tipoEsitoSpedizione: TipoEsitoSpedizione;
    motivoEsitoSpedizione: MotivoEsitoSpedizione;
    note: string;
}
